/* eslint-disable no-unneeded-ternary */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { DebounceInput } from 'react-debounce-input';
import posed, { PoseGroup } from 'react-pose';
import getUrlParameter from '../../utils/getParameters';

import NewsCard from '../Shared/Card/NewsCard';

const DefaultAmountBlogVid = 6;
const DefaultIncreaseBlogVid = 6;

const staggerDuration = 200;
const Child = posed.div({
  enter: {
    opacity: 1,
    y: 0,
    delay: ({ i }) => i * staggerDuration,
  },
  exit: {
    opacity: 0,
    y: 50,
  },
});

class InsightsIndex extends Component {
  constructor(props) {
    super(props);

    const searchTerm = getUrlParameter('searchTerm');
    const showBlogs = getUrlParameter('showBlogs');

    this.state = {
      SearchTerm: searchTerm ? searchTerm : '',
      TopNBlogs: showBlogs ? parseInt(showBlogs, 10) : -1,
      Blogs: [],
      BlogsOrder: [],
      Loading: true,
      BlogHeading: ''
    };

    this.BlogRef = null;

    this.getInsights(this.state);
  }

  getInsights = (state) => {
    const { documentAliasPath } = this.props;
    const {
      TopNBlogs, SearchTerm,
    } = state;
    const defaultCountBlog = TopNBlogs === -1
      ? DefaultAmountBlogVid : TopNBlogs;

    let csrf = document.querySelector('meta[name="csrf-token"]')
    csrf = csrf.content

    fetch(`/api/insights/?aliasPath=${documentAliasPath}&searchTerm=${SearchTerm}&topNBlogs=${defaultCountBlog}`, {
        headers: {
            'csrf-token': csrf
        }
      })
      .then(result => result.json())
      .then((res) => {
        // Blog Order
        const blogsIds = state.Blogs.map(p => p.id);
        const blogResultsIds = res.blogPosts.map(p => p.id);
        // Get the results that are in the second list but not first
        const newBlogIDs = blogResultsIds.filter(value => blogsIds.indexOf(value) === -1);

        this.setState({
          ...state,
          Blogs: res.blogPosts,
          BlogsCount: res.blogPostsCount,
          BlogsViewMore: res.blogPostsViewMore,
          BlogHeading: res.blogHeading,
          BlogsOrder: newBlogIDs,
          Loading: false,
        });
      });
  }

  handleLoadMore = (history, type) => {
    const newState = { ...this.state };
    switch (type) {
      case 'blog':
        if (newState.TopNBlogs === -1) {
          newState.TopNBlogs = DefaultAmountBlogVid + DefaultIncreaseBlogVid;
        } else {
          newState.TopNBlogs += DefaultIncreaseBlogVid;
        }
        break;
      default:
        break;
    }


    this.getInsights(newState);
    this.updateHistory(history, newState);
  }

  handleSearchUpdate = (history, newSearchTerm) => {
    const newState = { ...this.state };
    newState.SearchTerm = newSearchTerm;
    this.getInsights(newState);
    this.updateHistory(history, newState);
  }

  handleLoadAll = (history, type) => {
    const newState = { ...this.state };
    switch (type) {
      case 'blog':
        newState.TopNBlogs = newState.BlogsCount;
        break;
      default:
        break;
    }


    this.getInsights(newState);
    this.updateHistory(history, newState);
  }

  updateHistory = (history, newOptions) => {
    let newQueryString = '';
    if (newOptions.TopNBlogs && newOptions.TopNBlogs !== -1) {
      newQueryString += `&showBlogs=${newOptions.TopNBlogs}`;
    }
    if (newOptions.SearchTerm) {
      newQueryString += `&searchTerm=${newOptions.SearchTerm}`;
    }
    newQueryString = newQueryString.substring(1); // remove first &
    history.push({
      search: newQueryString,
    });
  }

  renderCards = (type, items, gridClasses) => {
    const {
      BlogsOrder
    } = this.state;
    if (items) {
      return (
        <div className={gridClasses}>
          <PoseGroup>
            {items.map((s) => {
              switch (type) {
                default:
                  return (
                    <Child key={s.id} i={BlogsOrder.indexOf(s.id)} className="grid-column">
                      <NewsCard
                        title={s.heading}
                        label={s.label}
                        tag={s.tag}
                        previewImageLg={s.previewImage.default}
                        previewImageSm={s.previewImage.maxWidth1024}
                        url={s.link.url}
                      />
                    </Child>
                  );
              }
            })}
          </PoseGroup>
        </div>
      );
    }
    return null;
  }

  renderHeader = (history, Heading, type) => {
    const {
      BlogsViewMore, PresentationsViewMore, PapersViewMore, VideosViewMore,
      BlogsCount, Loading,
    } = this.state;
    let count = 0;
    switch (type) {
      case 'blog':
        count = BlogsCount;
        break;
      default:
        break;
    }
    return (
      <div
        className="block-bar__list-block"
        ref={(element) => {
          switch (type) {
            case 'blog':
              this.BlogRef = element;
              break;
            default:
              break;
          }
          return null;
        }}
      >
        <div className="block-bar__title-container">
          <h3 className="block-bar__heading">{Heading}</h3>
          {!Loading ? (
            <div className="block-bar__results">
              {`${count} results`}
            </div>
          ) : null}
        </div>
        <div className="block-bar__button-container">
          {((type === 'blog' && BlogsViewMore))
            ? (
              <button
                type="button"
                onClick={() => this.handleLoadAll(history, type)}
                className="block-bar__view-all"
              >
                View All
              </button>
            ) : null}
        </div>
      </div>
    );
  }

  renderLoadMore = (history, type) => {
    const {
      BlogsViewMore
    } = this.state;
    if ((type === 'blog' && BlogsViewMore)) {
      return (
        <button
          className="mdc-button mdc-button--outlined mdc-ripple-upgraded"
          type="button"
          name="button"
          onClick={() => this.handleLoadMore(history, type)}
        >
          <span className="btn__text">Load More</span>
        </button>
      );
    }
    return null;
  }

  render() {
    const {
      BlogsCount, Loading,
      Blogs, SearchTerm,
      BlogHeading,
    } = this.state;
    return (
      <Route
        render={({ history }) => (
          <Fragment>
            <div className="banner__form">
              <div className="banner__form-search">
                <div className="field-container ">
                  <label
                    htmlFor="txtImpactSearch"
                    id="lblImpactSearch"
                    className="label sr-only"
                  >
                    Search Insights For
                  </label>
                  <div className="field-wrapper">
                    <span className="btn btn--reset field-wrapper__icon">
                      <svg className="icon-svg icon-search" viewBox="0 0 19.2 19.177">
                        <use xlinkHref="/application/themes/the_escape/assets/images/svgicons.svg#icon-search" />
                      </svg>
                    </span>
                    <DebounceInput
                      value={SearchTerm}
                      id="txtImpactSearch"
                      minLength={2}
                      debounceTimeout={500}
                      onChange={e => this.handleSearchUpdate(history, e.target.value)}
                      className="form-input form-input-search"
                      placeholder="Enter search term"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="theme-area-medium">
              <section className="search-filters js-sticky-filters">
                <div className="search-filters__container">
                  <div className="search-filters__items">
                  </div>
                </div>
              </section>
              <div className="site-wide">
                {this.renderHeader(history, BlogHeading, 'blog')}
                {this.renderCards('blog', Blogs,
                  'grid-container grid-container--half grid-container--half-mb')}
                <div className="block-bar">
                  <span className="block-bar__title ff-demi">
                    {Loading
                      ? 'Loading'
                      : `${BlogsCount} Result${BlogsCount === 1 ? '' : 's'}`}
                  </span>
                  {this.renderLoadMore(history, 'blog')}
                </div>
              </div>
            </div>
          </Fragment>
        )}
      />
    );
  }
}

InsightsIndex.defaultProps = {
};

InsightsIndex.propTypes = {
  documentAliasPath: PropTypes.string.isRequired,
};

export default InsightsIndex;
